import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {
  CommonUtility, ServerConstantsService, DataService, Components,
  DateUtility, DOUBLE_ROW_HEADER, TRIPLE_ROW_HEADER
} from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
@Component({
  selector: 'app-component-overall-progress',
  templateUrl: './component-overall-progress.component.html',
  styleUrls: ['./component-overall-progress.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class ComponentOverallProgressComponent implements OnInit {
  @ViewChild('header') header: ElementRef;
  serverConstants: any;
  TRIPLE_ROW_HEADER = TRIPLE_ROW_HEADER;

  editType;
  gridApi;
  context: any;
  columnDefs: any;
  progress = [];

  userActionNotificationsMap: any;
  trackStatusDescJson;
  trackStatusDescMap;

  empPlanId;
  component: Components[];
  selectedQuarter;
  tabToNextCell: any;
  loaderFocus : Boolean = false;
  quarters = [];
  componentIds = [];

  monthDetails = { Q1: '10-12', Q2: '1-3', Q3: '4-6', Q4: '7-9' };

  constructor(
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('COMPS') === undefined) {
      this.router.navigate(['/task']);
    }

  }

  ngOnInit() {
    this.dataService.globalAccess = false;
    //const end = new Date();
    const start = new Date();
    let year = start.getFullYear();
    if(start.getMonth() > 9){
      year = start.getFullYear() +1;
    }
    this.quarters = ['Q4'+ ' '+ year ,'Q3'+ ' '+ year,'Q2'+ ' '+ year,'Q1'+ ' '+ year]
    const fullYear = start.getFullYear();
    start.setFullYear(fullYear - 1);
    //this.quarters = this.listQuarters(start, end);
    /*while (this.quarters.length > 4) {
      this.quarters.splice(0, 1);
    }*/
    // this.quarters.reverse();
    if(start.getMonth()>9 && start.getMonth()<=12){
      this.selectedQuarter = this.quarters[3];
    }
    else if(start.getMonth()>6 && start.getMonth()<=9){
      this.selectedQuarter = this.quarters[0];
    }
    else if(start.getMonth()>3 && start.getMonth()<=6){
      this.selectedQuarter = this.quarters[1];
    }
    else{
      this.selectedQuarter = this.quarters[2];
    }
    
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);

    const trackStatusDesc = this.data.getValueFromSharedDataMap('METPLAN');
    this.trackStatusDescJson = this.commonUtil.createNativeMapFromList(trackStatusDesc);
    this.trackStatusDescMap = this.commonUtil.createMapFromList(trackStatusDesc);


    // Shared object access to get personId and componentId
    const sharedData = this.dataService.getSharedDataObject();

    if (sharedData.get('overAllProgressComponents') !== null && sharedData.get('overAllProgressComponents') !== undefined) {
      this.componentIds = sharedData.get('overAllProgressComponents');
    }
    this.getColumnDefinitions();

    if (this.componentIds !== undefined && this.componentIds.length > 0) {

      this.load();

    }

  }

  getQuarter(date) {
    return 'Q' + Math.ceil((date.getMonth() + 1) / 3) + ' ' + date.getFullYear();
  }
  reloadData(event) {
    this.loaderFocus = true;
    this.load();
  }
  listQuarters(sDate, eDate) {

    // Ensure start is the earlier date;
    if (sDate > eDate) {
      const t = eDate;
      eDate = sDate;
      sDate = t;
    }

    // Copy input start date do don't affect original
    sDate = new Date(sDate);

    // Set to 2nd of month so adding months doesn't roll over
    // and not affected by daylight saving
    sDate.setDate(2);

    // Initialise result array with start quarter
    let startQ = this.getQuarter(sDate);
    const endQ = this.getQuarter(eDate);
    const result = [startQ];

    // List quarters from start to end
    while (startQ !== endQ) {
      sDate.setMonth(sDate.getMonth() + 3);
      startQ = this.getQuarter(sDate);
      result.push(startQ);
    }

    return result;
  }





  load() {

    const quarterData = this.selectedQuarter.split(' ');
    const monthsData = this.monthDetails[quarterData[0]];
    const indMonth = monthsData.split('-');
    let request = new RequestLoad(this.componentIds, indMonth[0], indMonth[1], quarterData[1]);
    if(quarterData[0] === 'Q1'){
      request = new RequestLoad(this.componentIds, indMonth[0], indMonth[1], quarterData[1]-1);
    }
    this.http.post<OverallProgress[]>(this.serverConstants.SERVER_API_URL + '/component/overall-progress', request).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Track Component', this.userActionNotificationsMap.ERROR);
        } else {
          if (data !== null && data.length > 0) {
            this.progress = data;
            this.progress.sort((a, b) => new Date(b.month).getTime() - new Date(a.month).getTime());

            this.progress.forEach(element => {
              const date = element.month.trim().split('/');
              element.month = date[1] + '/' + date[0];
              element.actualAuthHrs = element.actualAuthHrs.toFixed(1);
              element.actualCountableHrs = element.actualCountableHrs.toFixed(1);
              element.plannedAuthHrs = element.plannedAuthHrs.toFixed(1);
              element.plannedCountableHrs = element.plannedCountableHrs.toFixed(1);
            });


          } else {
            this.progress = [];
          }
        }
      }, response => {

        this.notificationService.error('Track Component', this.userActionNotificationsMap.ERROR);
      }, () => {

      });

  }


  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Month', width: 130, field: 'month',
        // sort: 'desc'
      },

      {
        headerName: 'Planned Hours - Authorized', width: 130, field: 'plannedAuthHrs'
      },
      {
        headerName: 'Planned Hours - Countable', width: 130, field: 'plannedCountableHrs'
      },
      {
        headerName: 'Actual Hours - Completed', width: 130, field: 'actualAuthHrs'
      },
      {
        headerName: 'Actual Hours - Countable', width: 130, field: 'actualCountableHrs'
      },
      {
        headerName: 'Met Plan?', field: 'derivedMetPlanCd',
        refData: this.trackStatusDescJson, width: 130, valueGetter: this.getStatus

      },
      {
        headerName: 'Components Included', width: 150, field: 'components', cellRenderer: this.getEditButton,
        autoHeight: true,
      },

    ];
    this.context = {
      component: this,
    };
    this.tabToNextCell = function tabToNextCell(params) {
      var nextCell = params.nextCellDef;
      if (nextCell.column.colDef.headerName === "Components Included") {
        return;
      }
      else {
        return nextCell;
      }
    }


  }

  getEditButton(params) {
    const that = params.context.component;
    const divRow = document.createElement('div');
    divRow.setAttribute('class', 'row');

    if (params.value !== undefined && params.value.length > 0) {
      const compArray = params.value.split(',');
      compArray.forEach(componentId => {
        const element = document.createElement('a');
        if (componentId === compArray[compArray.length - 1]) {
          element.innerHTML = componentId;
        } else {
          element.innerHTML = componentId + ',';
        }

        element.addEventListener('click', () => {
          that.dataService.addValueToSharedDataMap('overall-component-id', componentId);
          that.router.navigate(['/task/componentSummary/componentDetails']);
        });
        element.addEventListener('keydown', (event) => {
          if (event.keyCode == 13 || event.keyCode == 32) {
            that.dataService.addValueToSharedDataMap('overall-component-id', componentId);
            that.router.navigate(['/task/componentSummary/componentDetails']);
          }

         /* else if ((!event.shiftKey && event.keyCode == 9) && (params.rowIndex == (that.progress.length - 1))) {
            event.preventDefault();
            setTimeout(() => that.header.nativeElement.focus(), 0);
            that.header.nativeElement.click();
          }*/
        });
        element.setAttribute("tabindex", "0");
        const divCol1 = document.createElement('div');
        divCol1.setAttribute('class', 'col-2 right-margin-1');
        divCol1.appendChild(element);
        divRow.appendChild(divCol1);
      });
    }
    return divRow;
  }
  addEventListenerToSearch(event) {
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.progress.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }
  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusHeader(event) {
    this.addEventListenerToSearch(event);
  }

  getStatus(params) {

    const that = params.context.component;
    return that.trackStatusDescMap.get(params.data.derivedMetPlanCd);
  }


  onGridReady(params) {
    this.gridApi = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridApi.columnDefs = this.columnDefs;
    } else {
      this.gridApi.sizeColumnsToFit();
    }
  }


  focusing(event){
    if(!event.shiftKey && event.keyCode===9) {
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }
}


class OverallProgress {
  constructor(

    public month: any,
    public plannedAuthHrs: any,
    public plannedCountableHrs: any,
    public ActualAuthHrs: any,
    public ActualCountableHrs: any,
    public derivedMetPlanCd: string,
    public components: any,

  ) {

  }
}


class RequestLoad {
  constructor(
    public ids: any,
    public from: any,
    public to: any,
    public year: any,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/component-overall-progress/component-overall-progress.component.ts